import { type ObjectDirective } from 'vue';
import { CLASS_ITEM, MODIFIER_ACTIVE, MODIFIER_HAS_OVERFLOW, MODIFIER_OVERFLOW } from './constants';
import { debounce } from '@dh-io-owpi/shared/src/utils/fn.util';

export const vTransitionOverflow: ObjectDirective<HTMLElement, string> = {
  mounted(el, binding) {
    const ro = new ResizeObserver(debounce(update, 300));
    const parentItemElement = el.closest(CLASS_ITEM);
    const childTextElement = el.firstElementChild as HTMLSpanElement | null;

    function update() {
      const hasOverflow = el.scrollHeight > el.offsetHeight;
      const isActive = parentItemElement?.classList.contains(MODIFIER_ACTIVE);

      el.classList.toggle(MODIFIER_HAS_OVERFLOW, hasOverflow);
      el.classList.toggle(MODIFIER_OVERFLOW, hasOverflow && !isActive);

      if (hasOverflow) {
        el.style.setProperty('--_max-height', el.scrollHeight + 'px');
        if (childTextElement)
          el.style.setProperty('--_overflow-position', el.offsetWidth - childTextElement.offsetWidth + 'px');
      }
    }

    el.addEventListener('transitionend', update);
    if (parentItemElement) ro.observe(parentItemElement);
    binding.dir.beforeUnmount = () => {
      el.removeEventListener('transitionend', update);
      ro.disconnect();
    };
  },
};
